<app-message></app-message>
<app-loader></app-loader>
<app-menu></app-menu>
